import { useEffect } from 'react';

import {
  type UserProfile,
  authenSelector,
  clearState,
  clearUserProfile,
  updateUserProfile,
  useAuthStore,
  userProfileSelector,
} from 'modules/auth/core';

import { apiCall } from 'hooks/service';

export const useMasterLayoutController = () => {
  const userProfile = useAuthStore(userProfileSelector);
  const authen = useAuthStore(authenSelector);
  const { token } = authen;

  useEffect(() => {
    if (userProfile?.id) {
      return;
    }

    getUserProfile();
  }, [userProfile?.id]);

  const getUserProfile = async () => {
    const result: UserProfile = await apiCall({
      url: `/auth/me`,
      method: 'GET',
      data: {
        token,
      },
      isLoading: false,
      showError: true,
    });

    if (result?.id) {
      updateUserProfile(result);
    }
  };
};

export const onLogout = () => {
  clearState();
  clearUserProfile();
};
